import { useTranslation } from 'react-i18next'
import SheetModal from '../sheet-modal/sheet-modal'
import step1Img from '../../../main/login/site-id-help/assets/images/step-1.png'
import step2Img from '../../../main/login/site-id-help/assets/images/step-2.png'
import screenshot from '../../../main/login/site-id-help/assets/images/ggstandoff-screenshot.png'
import c from './site-id-help-modal.module.scss'

const SiteIdHelpModal = () => {
    const { t } = useTranslation()

    const handleGoToSite = () => {
        const url = 'https://ggstand.live'
        try {
            if (window?.Telegram?.WebApp?.openLink) {
                window.Telegram.WebApp.openLink(url)
            } else {
                window.open(url, '_blank')
            }
        } catch (e) {
            window.open(url, '_blank')
        }
    }

    return (
        <SheetModal>
            <div className={c.component}>
                <h3 className={c.title}>{t('siteIdHelp.title')}</h3>
                <p className={c.subtitle}>{t('siteIdHelp.subtitle')}</p>

                <div className={c.steps}>
                    <div className={c.step}>
                        <img className={c.stepNumber} src={step1Img} alt="1" />
                        <div>
                            <div className={c.stepTitle}>{t('siteIdHelp.step1Title')}</div>
                            <div className={c.stepText}>{t('siteIdHelp.step1Text')}</div>
                        </div>
                    </div>
                    <div className={c.step}>
                        <img className={c.stepNumber} src={step2Img} alt="2" />
                        <div>
                            <div className={c.stepTitle}>{t('siteIdHelp.step2Title')}</div>
                            <div className={c.stepText}>{t('siteIdHelp.step2Text')}</div>
                        </div>
                    </div>
                </div>

                <div className={c.screenshot}>
                    <img src={screenshot} alt="GGSTANDOFF" />
                </div>

                <button className={c.button} onClick={handleGoToSite}>
                    {t('siteIdHelp.button')}
                </button>
            </div>
        </SheetModal>
    )
}

export default SiteIdHelpModal
